var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    strokeWidth: 0.00032,
    transform: "rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "id-card-vertical"), /*#__PURE__*/React.createElement("path", {
    d: "M24 1.25h-16c-1.518 0.002-2.748 1.232-2.75 2.75v24c0.002 1.518 1.232 2.748 2.75 2.75h16c1.518-0.002 2.748-1.232 2.75-2.75v-24c-0.002-1.518-1.232-2.748-2.75-2.75h-0zM25.25 28c-0.001 0.69-0.56 1.249-1.25 1.25h-16c-0.69-0.001-1.249-0.56-1.25-1.25v-24c0.001-0.69 0.56-1.249 1.25-1.25h16c0.69 0.001 1.249 0.56 1.25 1.25v0zM16 10.544c0 0 0 0-0 0-1.455 0-2.635 1.18-2.635 2.635s1.18 2.635 2.635 2.635c1.455 0 2.635-1.18 2.635-2.635 0-0 0-0 0-0v0c-0.002-1.455-1.18-2.633-2.635-2.635h-0zM16 14.313c0 0 0 0-0 0-0.627 0-1.135-0.508-1.135-1.135s0.508-1.135 1.135-1.135c0.627 0 1.135 0.508 1.135 1.135 0 0 0 0 0 0v0c-0.001 0.627-0.508 1.134-1.135 1.135h-0zM12.157 21.439c0.049 0.012 0.106 0.018 0.163 0.018 0.357 0 0.655-0.251 0.728-0.585l0.001-0.005c0.309-1.366 1.512-2.371 2.951-2.371s2.642 1.005 2.947 2.351l0.004 0.020c0.076 0.34 0.375 0.59 0.732 0.59 0.414 0 0.75-0.336 0.75-0.75 0-0.057-0.006-0.112-0.018-0.165l0.001 0.005c-0.46-2.046-2.262-3.552-4.416-3.552s-3.955 1.506-4.41 3.522l-0.006 0.030c-0.011 0.048-0.017 0.104-0.017 0.16 0 0.357 0.25 0.656 0.585 0.731l0.005 0.001zM22 25.277h-12c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h12c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0zM14 6.75h4c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-4c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id_card.30fb500bbbc8633bf6f65fd3a72c5e73.svg";
export { ForwardRef as ReactComponent };